import "./index.scss"
import React from "react"
import { Link } from "gatsby"

const JobCard = ({ job }) => {
  const {
    datePosted,
    description,
    organization,
    role,
    slug,
    typeOfPosition,
    title,
    location,
  } = job

  return (
    <div className="job-card">
      <div className="col-md-9">
        <div className="job-card__data">
          <span className="job-card__date">{datePosted}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span className="job-card__organization">{organization}</span>
        </div>

        <Link to={`/jobs/${slug}`} className="job-card__title">
          {title}
        </Link>

        <div className="job-card__tags">
          {location && <span className="job-card__tag">{location}</span>}
          {typeOfPosition && (
            <span className="job-card__tag">{typeOfPosition}</span>
          )}
        </div>

        <div
          className="job-card__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <div className="job-card__link">
          <Link to={`/jobs/${slug}`} className="btn btn--job">
            Read more and apply
          </Link>
        </div>
      </div>
    </div>
  )
}

export default JobCard
